import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dhl = defineConnector({
  identifier: "dhl",
  name: "DHL",
  tagLine: "Shipping and logistics",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api-eu\\.dhl\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "DHL-API-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to the [DHL Developer Portal](https://developer.dhl.com/) and create an app to get your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api-eu.dhl.com/track/shipments?trackingNumber=0",
  },
});
